import { useState } from 'react';
import { C } from '../theme/palette';
import { FS } from '../theme/typo';
import { activeNouvelleVersion, useNouvelleVersion } from './miseAJour';

/**
 * Bannière « Nouvelle version disponible ».
 *
 * <p>Elle se referme d'un « Plus tard » : la nouvelle version attend, et
 * prendra la main au prochain démarrage de l'application.
 *
 * @param {object} props propriétés du composant
 * @param {ServiceWorker|null} props.worker la version en attente ; rien sans elle
 * @param {() => void} [props.onRecharger] action du bouton (par défaut, active la version)
 * @param {() => void} [props.onIgnorer] action de « Plus tard »
 * @returns {JSX.Element|null} la bannière
 */
export function BanniereMiseAJour({ worker, onRecharger, onIgnorer }) {
  if (!worker) return null;
  return (
    <div
      className="no-print"
      role="status"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        flexWrap: 'wrap',
        background: C.teal,
        color: '#fff',
        padding: '8px 12px',
        fontSize: FS.sm,
        fontWeight: 700,
      }}
    >
      <span>🔄 Nouvelle version disponible.</span>
      <button
        type="button"
        onClick={onRecharger || (() => activeNouvelleVersion(worker))}
        style={{
          background: '#fff',
          color: C.teal,
          border: 'none',
          borderRadius: 8,
          padding: '8px 14px',
          fontSize: FS.sm,
          fontWeight: 800,
          cursor: 'pointer',
        }}
      >
        Recharger
      </button>
      {onIgnorer && (
        <button
          type="button"
          onClick={onIgnorer}
          style={{
            background: 'transparent',
            color: '#fff',
            border: '1px solid rgba(255,255,255,.6)',
            borderRadius: 8,
            padding: '8px 12px',
            fontSize: FS.sm,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          Plus tard
        </button>
      )}
    </div>
  );
}

/** La bannière branchée sur le service worker. */
export function BanniereMiseAJourConnectee() {
  const worker = useNouvelleVersion();
  const [ignoree, setIgnoree] = useState(null);
  if (worker && worker === ignoree) return null;
  return <BanniereMiseAJour worker={worker} onIgnorer={() => setIgnoree(worker)} />;
}
